import { createDebugger } from '@iotize/common/debug';

const prefix = '@iotize/tap/relay';

export const debug = createDebugger(prefix);
